export var DEAL_INFO_TYPES;
(function (DEAL_INFO_TYPES) {
    DEAL_INFO_TYPES["RENT"] = "rent";
    DEAL_INFO_TYPES["SALE"] = "sale";
    DEAL_INFO_TYPES["SUBSCRIPTION"] = "subscription";
    DEAL_INFO_TYPES["PLAN"] = "pricing_plan";
})(DEAL_INFO_TYPES || (DEAL_INFO_TYPES = {}));
//# sourceMappingURL=deal-info-types.js.map